import axios from "axios"
import type { AxiosRequestConfig, AxiosError,AxiosResponse } from "axios"
import { useMutation } from "@tanstack/react-query"
import type {  
    UseMutationOptions,   
    MutationFunction,   
} from "@tanstack/react-query";
import type {
  
    HTTPValidationError,
    SPLotStatus,
    BeginProcessingModel,
    MarkAsDoneModel,
    SkipStepModel,
    WorkFlowCommentModel
  
} from "./"

/**
 * @summary Search  SPLot
 */
export const countsSPLotStatus= (site_code: string, crop_code: string, options?: AxiosRequestConfig): Promise<SPLotStatus> => {
    const cropQuery = crop_code ? `?crop_code=${encodeURIComponent(crop_code)}` : '';
    return axios.get(`/api/v1/splot-counts/${encodeURIComponent(site_code)}${cropQuery}`, options)
}

export const useCountsSPLotStatus= <TError = AxiosError<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof countsSPLotStatus>>, TError, { site_code: string, crop_code: string }, TContext>
    axios?: AxiosRequestConfig
}) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof countsSPLotStatus>>, { site_code: string, crop_code: string }> = (props) => {
        return countsSPLotStatus(props.site_code, props.crop_code, axiosOptions)
    }

    return useMutation<Awaited<ReturnType<typeof countsSPLotStatus>>, TError, { site_code: string, crop_code: string }, TContext>(
        mutationFn,
        mutationOptions
    )
}


export const beginProcessing = (data: BeginProcessingModel, options?: AxiosRequestConfig): Promise<AxiosResponse> => {
    return axios.post(`/api/v1/begin-processing`, data, options)
}
export const useBeginProcessing= <TError = AxiosError<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof beginProcessing>>, TError, { data: BeginProcessingModel }, TContext>
    axios?: AxiosRequestConfig
}) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof beginProcessing>>, { data: BeginProcessingModel }> = (props) => {
        const { data } = props ?? {}
        return beginProcessing(data, axiosOptions)
    }
    return useMutation<Awaited<ReturnType<typeof beginProcessing>>, TError, { data: BeginProcessingModel }, TContext>(
        mutationFn,
        mutationOptions
    )
}


export const markAsDone = (data: MarkAsDoneModel, options?: AxiosRequestConfig): Promise<AxiosResponse> => {
    return axios.post(`/api/v1/mark-as-done`, data, options)
}
export const useMarkAsDone= <TError = AxiosError<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof markAsDone>>, TError, { data: MarkAsDoneModel }, TContext>
    axios?: AxiosRequestConfig
}) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAsDone>>, { data: MarkAsDoneModel }> = (props) => {
        const { data } = props ?? {}
        return markAsDone(data, axiosOptions)
    }
    return useMutation<Awaited<ReturnType<typeof markAsDone>>, TError, { data: MarkAsDoneModel }, TContext>(
        mutationFn,
        mutationOptions
    )
}

export const skipStep = (data: SkipStepModel, options?: AxiosRequestConfig): Promise<AxiosResponse> => {
    return axios.post(`/api/v1/skip-step`, data, options)
}
export const useSkipStep= <TError = AxiosError<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof skipStep>>, TError, { data: SkipStepModel }, TContext>
    axios?: AxiosRequestConfig
}) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof skipStep>>, { data: SkipStepModel }> = (props) => {
        const { data } = props ?? {}
        return skipStep(data, axiosOptions)
    }
    return useMutation<Awaited<ReturnType<typeof skipStep>>, TError, { data: SkipStepModel }, TContext>(
        mutationFn,
        mutationOptions
    )
}


export const activeSplots= (site_code: string, crop_code: string, options?: AxiosRequestConfig): Promise<SPLotStatus> => {
    const cropQuery = crop_code ? `?crop_code=${encodeURIComponent(crop_code)}` : '';
    return axios.get(`/api/v1/active-splots-by-crop-site/${encodeURIComponent(site_code)}${cropQuery}`, options)
}

export const useActiveSplots= <TError = AxiosError<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof activeSplots>>, TError, { site_code: string, crop_code: string }, TContext>
    axios?: AxiosRequestConfig
}) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof activeSplots>>, { site_code: string, crop_code: string }> = (props) => {
        return activeSplots(props.site_code, props.crop_code, axiosOptions)
    }

    return useMutation<Awaited<ReturnType<typeof activeSplots>>, TError, { site_code: string, crop_code: string }, TContext>(
        mutationFn,
        mutationOptions
    )
}

export const updateWorkFlowComment = (data: WorkFlowCommentModel, options?: AxiosRequestConfig): Promise<AxiosResponse> => {

   
    return axios.post(`/api/v1/splot/step/comment`, data, options)
}
export const useUpdateComment= <TError = AxiosError<HTTPValidationError>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof updateWorkFlowComment>>, TError, { data: WorkFlowCommentModel }, TContext>
    axios?: AxiosRequestConfig
}) => {
    const { mutation: mutationOptions, axios: axiosOptions } = options ?? {}

    const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateWorkFlowComment>>, { data: WorkFlowCommentModel }> = (props) => {
        const { data } = props ?? {}
        return updateWorkFlowComment(data, axiosOptions)
    }
    return useMutation<Awaited<ReturnType<typeof updateWorkFlowComment>>, TError, { data: WorkFlowCommentModel }, TContext>(
        mutationFn,
        mutationOptions
    )
}